import { Map } from 'immutable';
import { ERROR, UPDATE_PAGE_SETTINGS } from '../resource/ResourcesActionTypes';
import { LOGIN_FAILURE } from '../auth/AuthActionTypes';

export default function ErrorReducer(state = Map({ errors: [] }), action) {
  switch (action.type) {
    case ERROR:
    case LOGIN_FAILURE:
      return state.update('errors', errors => action.error);
    case UPDATE_PAGE_SETTINGS:
      return state;
    default:
      return state.update('errors', errors => action.error);
  }
}
